let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1RsAv")).then(() => parcelRequire('8Iexw'));